import {
  TContractActionType,
  TMasterContractStatus,
  ZContractActionType,
  ZMasterContractStatus,
} from '../model/schema'

export const masterContractStatusDisplayText: Record<
  TMasterContractStatus,
  string
> = {
  [ZMasterContractStatus.Enum.REVIEWING]: '계약대기',
  [ZMasterContractStatus.Enum.READY]: '입주대기',
  [ZMasterContractStatus.Enum.ACTIVE]: '거주중',
  [ZMasterContractStatus.Enum.TERMINATING]: '퇴실중',
  [ZMasterContractStatus.Enum.CLOSED]: '계약종료',
  [ZMasterContractStatus.Enum.CANCELED]: '취소',
  [ZMasterContractStatus.Enum.PAYMENT_CANCELED]: '결제취소',
}

export const actionTypeDisplayText: Record<TContractActionType, string> = {
  [ZContractActionType.Enum.WAITING_APPROVAL]: '승인대기',
  [ZContractActionType.Enum.WAITING_CHECKIN]: '입주예정',
  [ZContractActionType.Enum.WAITING_CHECKOUT]: '퇴실예정',
  [ZContractActionType.Enum.WAITING_CHECK_FINISH]: '퇴실점검',
}

export const actionTypeTooltipText: Record<TContractActionType, string> = {
  [ZContractActionType.Enum.WAITING_APPROVAL]:
    '호스트의 승인을\n기다리는 계약입니다',
  [ZContractActionType.Enum.WAITING_CHECKIN]:
    '계약 확정 후부터\n입주 확인 전까지의 계약입니다',
  [ZContractActionType.Enum.WAITING_CHECKOUT]:
    '퇴실일 3일 전부터\n전날까지의 계약입니다',
  [ZContractActionType.Enum.WAITING_CHECK_FINISH]:
    '퇴실일 도래 또는 중도 퇴실 후,\n퇴실 점검을 기다리는 계약입니다',
}

export const getContractNotice = ({
  isExtend,
}: { isExtend?: boolean } = {}) => {
  if (isExtend) {
    return [
      '연장계약은 청소비와 보증금이 청구되지 않습니다.',
      '퇴실 후 재입주하시는 경우에는 새로운 계약으로 요청해 주세요.',
    ]
  }

  return [
    '단기임대의 최대 계약기간은 12주입니다.',
    `13주 이상 계약을 원하실 경우, 계약 체결 후 거주 기간 연장을\n신청해 주세요.`,
  ]
}
